var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1554FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1533 22C17.0361 22.2021 16.8679 22.3698 16.6655 22.4864C16.4631 22.6029 16.2336 22.6643 16 22.6643C15.7664 22.6643 15.5369 22.6029 15.3345 22.4864C15.1321 22.3698 14.9639 22.2021 14.8467 22",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.3335C20 12.2726 19.5786 11.2552 18.8284 10.5051C18.0783 9.75492 17.0609 9.3335 16 9.3335C14.9391 9.3335 13.9217 9.75492 13.1716 10.5051C12.4214 11.2552 12 12.2726 12 13.3335C12 18.0002 10 19.3335 10 19.3335H22C22 19.3335 20 18.0002 20 13.3335Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.54203a5e202a53c6300324138c8b1d80.svg";
export { ForwardRef as ReactComponent };